import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import { Dealer } from '../../../models/dealer';

export const handleMapMarkerClick = () => {
  const { selectedDealerId } = mapContext.useMapState();
  const dispatch = mapContext.useMapDispatch();
  const { isSidebarOpen, isFiltersOverlayOpen } = mapContext.useMapState();

  return (dealer: Dealer) => {
    if (dealer.dealerId !== selectedDealerId) {
      if (isFiltersOverlayOpen) {
        dispatch({
          type: ActionTypes.setIsFiltersOverlayOpen,
          payload: false,
        });
      }
      dispatch({
        type: ActionTypes.setSelectedDealerId,
        payload: dealer.dealerId,
      });
      dispatch({
        type: ActionTypes.setRatingSummary,
        payload: null,
      });
      dispatch({
        type: ActionTypes.setSelectedPartner,
        payload: { kvpsid: dealer.kvpsId, tenant: dealer.country },
      });

      if (!isSidebarOpen) {
        dispatch({ type: ActionTypes.setIsSidebarOpen, payload: true });
      }
    }
  };
};
